/** Throw if a tile face references an out-of-range or contradictory node. */
export function validateTile(tile) {
    for (const face of [tile.faceA, tile.faceB]) {
        const seen = new Set();
        for (const r of face.resources) {
            if (r.node < 0 || r.node >= tile.nodeCount) {
                throw new Error(`${tile.id}: resource node ${r.node} out of range`);
            }
            if (seen.has(r.node)) {
                throw new Error(`${tile.id}: node ${r.node} has multiple resources`);
            }
            seen.add(r.node);
        }
        for (const [a, b] of face.disconnectedPaths) {
            if (a < 0 || a >= tile.nodeCount || b < 0 || b >= tile.nodeCount) {
                throw new Error(`${tile.id}: severed path ${a}-${b} out of range`);
            }
            if (a === b) {
                throw new Error(`${tile.id}: severed path ${a}-${b} is not an edge`);
            }
        }
        for (const [n, dir] of face.disconnectedExits ?? []) {
            if (n < 0 || n >= tile.nodeCount) {
                throw new Error(`${tile.id}: severed exit node ${n} out of range`);
            }
            if (dir < 0 || dir > 5) {
                throw new Error(`${tile.id}: severed exit dir ${dir} out of range (0-5)`);
            }
        }
    }
}
//# sourceMappingURL=types.js.map